/** WORLD777-style stake chip buttons — stored in localStorage */

const STORAGE_KEY = "w777_game_buttons";

export const DEFAULT_GAME_BUTTONS = [
  { label: "1k", value: 1000 },
  { label: "2k", value: 2000 },
  { label: "5k", value: 5000 },
  { label: "10k", value: 10000 },
  { label: "20k", value: 20000 },
  { label: "25k", value: 25000 },
  { label: "50k", value: 50000 },
  { label: "75k", value: 75000 },
  { label: "90k", value: 90000 },
  { label: "95k", value: 95000 },
];

export const DEFAULT_CASINO_BUTTONS = [
  { label: "100", value: 100 },
  { label: "200", value: 200 },
  { label: "500", value: 500 },
  { label: "1k", value: 1000 },
  { label: "2k", value: 2000 },
  { label: "5k", value: 5000 },
  { label: "10k", value: 10000 },
  { label: "20k", value: 20000 },
  { label: "50k", value: 50000 },
  { label: "1L", value: 100000 },
];

export function loadStakeButtons(kind = "game") {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return kind === "casino" ? [...DEFAULT_CASINO_BUTTONS] : [...DEFAULT_GAME_BUTTONS];
    }
    const parsed = JSON.parse(raw);
    const list = kind === "casino" ? parsed?.casino : parsed?.game;
    if (Array.isArray(list) && list.length) {
      return list.map((row) => ({
        label: String(row.label || ""),
        value: Math.max(0, Math.floor(Number(row.value) || 0)),
      }));
    }
  } catch {
    /* ignore */
  }
  return kind === "casino" ? [...DEFAULT_CASINO_BUTTONS] : [...DEFAULT_GAME_BUTTONS];
}

export function saveStakeButtons(game, casino) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      game: game || DEFAULT_GAME_BUTTONS,
      casino: casino || DEFAULT_CASINO_BUTTONS,
    })
  );
  window.dispatchEvent(new Event("w777-buttons-updated"));
}
